var externalLinkHandling = function () {
    $("section[aria-labelledby='related-label'] ul li a, div ul.m-list-tasks li a.btn-primary").each(function () {

        var href = this.href;
        var hostname = this.hostname;

        // Only act on real links
        if (!href) return;

        // Check if link is external AND not an islington.gov.uk link
        if (hostname !== window.location.hostname && href.indexOf("islington.gov.uk") === -1) {
            $(this).attr("target", "_blank");
        }
    });
};
